/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */
import { SxProps, Theme, InputBase } from '@mui/material';
import styled from '@emotion/styled';

export const titleSX: SxProps<Theme> = {
	fontSize: 'var(--font-size-xl)',
	letterSpacing: '0px',
	color: '#2C2C2C',
	fontWeight: '900',
	opacity: 1,
};

export const ProductSizeIconSx: SxProps = {
	color: '#011688',
};

export const ProductSizeSelectSx: SxProps = {
	height: '32px !important',
	'.MuiSelect-nativeInput': {
		padding: '0px',
	},
};

export const ProductSizeInput = styled(InputBase)({
	width: '95px !important',
	padding: '0px',
	'& .MuiInputBase-input': {
		position: 'relative',
		backgroundColor: '#FFFFFF',
		border: '1px solid #C9C9C9',
		fontSize: 'var(--font-size-small)',
		padding: '4px',
		borderRadius: '2px',
	},
	'& .MuiSelect-icon': {
		color: '#011688',
	},
	'&:hover': {
		backgroundColor: 'transparent',
	},
});

export const ProductSizeTextSx = ({ isDrawer }: { isDrawer?: boolean }): SxProps => ({
	display: 'flex',
	alignItems: 'center',
	fontSize: isDrawer ? 'var(--font-size-small)' : 'initial',
	color: isDrawer ? '#707070' : 'initial',
});
